import { Global } from '@emotion/react';
import { globalStyle, VersionUpDialogProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';

export function RootContainer() {
  return (
    <>
      <Global styles={globalStyle} />
      <VersionUpDialogProvider>
        <Outlet />
      </VersionUpDialogProvider>
    </>
  );
}
